// import React, { useState } from "react";
// import { db } from "../../firebase";
// import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// function ContactForm() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await addDoc(collection(db, "contacts"), {
//         ...formData,
//         createdAt: serverTimestamp(), // Firestore timestamp
//         createdAtDate: new Date(),    // JS date for queries
//       });
//       alert("Message submitted successfully!");
//       setFormData({ name: "", email: "", message: "" });
//     } catch (error) {
//       console.error("Error:", error);
//       alert("Failed to save data.");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <input
//         type="text"
//         name="name"
//         placeholder="Name"
//         value={formData.name}
//         onChange={handleChange}
//         required
//       />
//       <input
//         type="email"
//         name="email"
//         placeholder="Email"
//         value={formData.email}
//         onChange={handleChange}
//         required
//       />
//       <textarea
//         name="message"
//         placeholder="Message"
//         value={formData.message}
//         onChange={handleChange}
//         required
//       />
//       <button type="submit">Submit</button>
//     </form>
//   );
// }

// export default ContactForm;



import React, { useState } from "react";
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function ContactForm() {
  
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    address: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        createdAt: serverTimestamp(), // Firestore Timestamp
        createdAtDate: new Date(),    // Plain JS Date for Excel
      });
      alert("Message submitted successfully!");
      setFormData({ name: "", mobile: "", address: "" });
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to save data.");
    }
  };

  return (
    <div style={{margin:"0px", padding:"17px"}} className="card">
      <center> <h3 style={{color:"#000061"}}><b>কেবল মাত্র আগ্রহি ব্যক্তি যোগাযোগ করবেন।</b></h3></center>
    <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
      <input className="mb-2"
        type="text"
        name="name"
        placeholder="আপনার নাম"
        value={formData.name}
        onChange={handleChange}
        required
      />
      <input className="mb-2"
        type="mobile"
        name="mobile"
        placeholder="আপনার ফোন নাম্বার"
        value={formData.mobile}
        onChange={handleChange}
        required
      />
      <textarea
        name="address"
        placeholder="আপনার ঠিকানা"
        value={formData.address}
        onChange={handleChange}
        required
      />
      <center>
      <button className="colorbutton mt-2" type="submit">Submit</button>
      </center>
    </form>
    </div>
  );
}

export default ContactForm;
